<template>
    <div class="modal" v-if="active" @click.self="close">
        <div class="modal-box">
            <div class="modal-header">
                <div class="modal-header-text">
                    {{title}}
                </div>
            </div>
            <div class="modal-body">
                <pre v-if="this.courseRemark != null && this.courseRemark != ''" style="width:560px; white-space:pre-wrap; ">{{this.courseRemark}}</pre>
                <pre v-else style="width:560px; white-space:pre-wrap; ">     暂无简介</pre>
                <section>
                    <component
                            :is="component"
                            :data="data"
                            @ok="receive"
                            :confirmEvent="confirmEvent"
                            v-model="active"></component>
                </section>
            </div>
            <div class="modal-footer" v-show="disableDefaultFunctions">
                <div class="button-confirm" @click.self="close">
                    关闭
                </div>
                <!-- <div class="button-confirm" @click.self="confirm" >
                    确定
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    import Hub from '../events/Hub';

    export default {
        name: "BPopup",
        data() {
            return {
                active: false,
                data: {},
                title: null,
                confirmData: null,
                confirmEvent: false,
                disableDefaultFunctions: true,
                courseRemark: null,
            }
        },
        props: {
            display: String,
        },
        methods: {
            receive(value) {
                Hub.$emit('modal-confirm3',value);
                this.confirmEvent = false;
            },

            close() {
                this.active = false;
            },

            confirm() {
                this.confirmEvent = true;
                // this.active = false;
            },

            open() {
                this.active = true;
            },

            set(data, title, component,disableDefaultFunctions) {
                this.confirmEvent = false;
                this.data = data;
                this.title = title;
                // this.component = title.split(' ').join('-').toLowerCase(); // of course you could just pass the component through the method too...
                this.component = component;
                if(typeof disableDefaultFunctions !== "undefined"){
                    this.disableDefaultFunctions = disableDefaultFunctions;
                }

                if (
                    this.data !== null &&
                    this.data !== "" &&
                    this.data !== undefined
                ) {
                    this.courseRemark = this.data.courseRemark;
                }
            }
        },
        destroyed() {
            Hub.$off('set-modal-data3', this.set);
            Hub.$off('open-modal3', this.open);
            this.confirmEvent = false;
        },
        mounted() {
            this.$nextTick(function () {
                Hub.$on('set-modal-data3', this.set);
                Hub.$on('open-modal3', this.open);
            }.bind(this));
        }
    }
</script>

<style>
    .modal {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
        opacity: 1;
        visibility: inherit;
        z-index: 10;
        -webkit-transition: .3s;
        transition: .3s;
    }

    .modal-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
        padding: 1rem 1.5rem;
        border-radius: 0.5rem;
    }

    .close-button {
        float: right;
        width: 1.5rem;
        line-height: 1.5rem;
        text-align: center;
        cursor: pointer;
        border-radius: 0.25rem;
        background-color: lightgray;
    }

    .show-modal {
        opacity: 1;
        visibility: visible;
        transform: scale(1.0);
        -webkit-transition: .5s;
        transition: .5s;
    }

    .modal-footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .button-confirm {
        display: flex;
        width: 124px;
        height: 46px;
        background: #0171A3;
        border-radius: 5px;
        color: #FEFEFE;
        justify-content: center;
        align-items: center;
        margin: 5px;
        cursor: pointer;
    }

    .button-cancel {
        display: flex;
        width: 124px;
        height: 46px;
        background: #FFFFFF;
        border: 1px solid #CBCBCB;
        border-radius: 5px;
        justify-content: center;
        align-items: center;
        margin: 5px;
        cursor: pointer;
    }

    .modal-body {
        padding: 1em 0;
    }

    .modal-header {
        /*margin: 0 1em;*/
    }

    .modal-header-text {
        font-size: 20px;
    }

</style>